
import { defineComponent, PropType, ref } from 'vue'
import { includes } from 'ramda'

interface BoxLink {
	url: string;
	title?: string;
	subtitle?: string;
	image?: string;
}

const count = ref<number>(0)

export default defineComponent({
	name: 'BoxLinks',

	props: {
		title: { type: String, default: '' },
		items: { type: Array as PropType<BoxLink[]>, default: () => [] }
	},

	setup () {
		count.value++

		return { count, includes }
	}
	
})
